import { isAppleDevice } from "~/utils/user-agent";

// Apple keyboards use ⌘, the others Ctrl (the Windows key is taken by the operating system)
export const getPlatformModifierKeyLabel = () => (isAppleDevice() ? "⌘" : "Ctrl");

export const isPlatformModifierKeyPressed = (event: Pick<KeyboardEvent, "metaKey" | "ctrlKey">) =>
  isAppleDevice() ? event.metaKey : event.ctrlKey;
